export const FONT_STYLE_TEXTS = {
  primary: 'font-primary',
  secondary: 'font-secondary',
};

export const FONT_SIZE_TEXT = {
  base: 'text-xs md:text-base lg:text-lg',
  sm: 'text-xs md:text-xs lg:text-xs',
};

export const THEME_COLORS_BUTTON = {
  primary: {
    text: 'text-white',
    bg: 'bg-primary-500 hover:bg-primary-600 active:bg-primary-800',
    border: 'rounded-md transition-all duration-300 ease-in-out',
  },
  danger: {
    text: 'text-white',
    bg: 'bg-danger-500 hover:bg-danger-600 active:bg-danger-800',
    border: 'rounded-md transition-all duration-300 ease-in-out',
  },
  success: {
    text: 'text-white',
    bg: 'bg-success-500 hover:bg-success-600 active:bg-success-800',
    border: 'rounded-md transition-all duration-300 ease-in-out',
  },
  warning: {
    text: 'text-white',
    bg: 'bg-warning-500 hover:bg-warning-600 active:bg-warning-800',
    border: 'rounded-md transition-all duration-300 ease-in-out',
  },
  info: {
    text: 'text-white',
    bg: 'bg-info-500 hover:bg-info-600 active:bg-info-800',
    border: 'rounded-md transition-all duration-300 ease-in-out',
  },
  neutral: {
    text: 'text-primary-500 hover:text-primary-600 active:text-primary-800',
    bg: 'bg-transparent',
    border: 'rounded-md transition-all duration-300 ease-in-out border border-primary-500 hover:border-primary-600 hover:bg-gray-100 border-solid active:border-primary-800',
  },
  light: {
    text: 'text-primary-600 hover:text-primary-900 active:text-primary-900',
    bg: 'bg-none',
    border: '',
  },
  kazaarPrimary: {
    text: 'text-white',
    bg: 'bg-kazaarBrand-400 hover:bg-kazaarBrand-200 active:bg-kazaarBrand-200',
    border: 'rounded-md transition-all duration-300 ease-in-out',
  },
  kazaarSecondary: {
    text: 'text-kazaarBrand-400',
    bg: 'bg-kazaarBrand-50 hover:bg-kazaarBrand-00 active:bg-kazaar-200',
    border: 'rounded-md transition-all duration-300 ease-in-out',
  },
  kazaarTertiary: {
    text: 'text-white',
    bg: 'bg-kazaar-500 hover:bg-kazaar-600 active:bg-kazaar-800',
    border: 'rounded-md transition-all duration-300 ease-in-out',
  },
  secondary: {
    text: 'text-white',
    bg: 'bg-secondary-500 hover:bg-secondary-600 active:bg-secondary-800',
    border: 'rounded-md transition-all duration-300 ease-in-out',
  },
  tertiary: {
    text: 'text-primary-500',
    bg: 'bg-transparent hover:bg-gray-100 active:bg-gray-200',
    border: 'rounded-md transition-all duration-300 ease-in-out',
  },
  transparent: {
    text: 'text-primary-500',
    bg: 'bg-transparent hover:bg-gray-100 active:bg-gray-200',
    border: 'rounded-md transition-all duration-300 ease-in-out border border-primary-500 border-solid',
  },
};
